import { useCallback, useEffect, useMemo, useState } from "react";
import { _EmployeeContract } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Alert } from "../../theme/Component/Alert";
import { PrintJson } from "../../theme/Component/PrintJson";
import { PayrollTypeSelect } from "./PayrollFactor/PayrollTypeSelect";
import { toast } from "react-toastify";
import { BasicButton } from "../../theme/Component/BasicButton";

interface Props {
    employeeLiquidate: any;
}
export const MigrateEmployeeLiquidate = ({ employeeLiquidate }: Props) => {

    const _employeeContracts = useDataBean(_EmployeeContract);

    const [payroll,setPayRoll]= useState<number>(0);
    const [list, setList] = useState<any>([]);

    const migrateEmployeeLiquidate = ()=>{
        if(payroll>0)
        {
            _employeeContracts.instance.migrateEmployeeLiquidate(employeeLiquidate.IDEmployeeLiquidate,payroll).then((resp:any)=>{                        
                setList(resp);                
            })
        }else{
            toast.warning("Seleccione un tipo de payroll");
        }
    }
    return (
        <div className="row">
                  <div className="col">                     
                      <div className="row">
                        <div className="col-md-12">
                            {employeeLiquidate.Name}
                        </div>
                        <div className="col-md-6">
                            <PayrollTypeSelect  idSelector={payroll} onChange={(e)=>{setPayRoll(e)}}/>
                                <br />
                            <BasicButton icon="" eventClick={migrateEmployeeLiquidate}>Grabar</BasicButton>

                        </div>                        
                          <div className="col-md-12">
                              <div className="list-group mt-3">
                                  {list.map((item:any)=>{
                                      return(
                                          <div className="list-group-item">
                                              {item}
                                          </div>  
                                      )
                                  })}
                              </div>
                          </div>
                      </div>                                           
                  </div>
              </div>
    )
}